import AdvanceGroupActivityList from './AdvanceGroupActivityList';

export default AdvanceGroupActivityList;
